import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=0ca5677e&scoped=true&"
import script from "./Slideshow.vue?vue&type=script&lang=js&"
export * from "./Slideshow.vue?vue&type=script&lang=js&"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=0ca5677e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5677e",
  null
  
)

component.options.__file = "Slideshow.vue"
export default component.exports